/* tslint:disable */
/* eslint-disable */
/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { UserSubmission } from '../models';
/**
 * ProjectsApi - axios parameter creator
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} artistId 
         * @param {string} teamId2 
         * @param {string} [workflowId] 
         * @param {string} [teamId] 
         * @param {boolean} [createPartialProject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistsArtistIdTeamsTeamIdProjectsGet: async (artistId: string, teamId2: string, workflowId?: string, teamId?: string, createPartialProject?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artistId' is not null or undefined
            assertParamExists('apiArtistsArtistIdTeamsTeamIdProjectsGet', 'artistId', artistId)
            // verify required parameter 'teamId2' is not null or undefined
            assertParamExists('apiArtistsArtistIdTeamsTeamIdProjectsGet', 'teamId2', teamId2)
            const localVarPath = `/api/artists/{artistId}/teams/{teamId}/Projects`
                .replace(`{${"artistId"}}`, encodeURIComponent(String(artistId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId2)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workflowId !== undefined) {
                localVarQueryParameter['workflowId'] = workflowId;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }

            if (createPartialProject !== undefined) {
                localVarQueryParameter['createPartialProject'] = createPartialProject;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} artistId 
         * @param {boolean} [createNewProject] 
         * @param {string} [workflowId] 
         * @param {string} [projectId] 
         * @param {string} [nodeId] 
         * @param {UserSubmission} [userSubmission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistsArtistIdTeamsTeamIdProjectsPost: async (teamId: string, artistId: string, createNewProject?: boolean, workflowId?: string, projectId?: string, nodeId?: string, userSubmission?: UserSubmission, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiArtistsArtistIdTeamsTeamIdProjectsPost', 'teamId', teamId)
            // verify required parameter 'artistId' is not null or undefined
            assertParamExists('apiArtistsArtistIdTeamsTeamIdProjectsPost', 'artistId', artistId)
            const localVarPath = `/api/artists/{artistId}/teams/{teamId}/Projects`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"artistId"}}`, encodeURIComponent(String(artistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createNewProject !== undefined) {
                localVarQueryParameter['createNewProject'] = createNewProject;
            }

            if (workflowId !== undefined) {
                localVarQueryParameter['workflowId'] = workflowId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSubmission, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} artistId 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet: async (projectId: string, artistId: string, teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet', 'projectId', projectId)
            // verify required parameter 'artistId' is not null or undefined
            assertParamExists('apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet', 'artistId', artistId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet', 'teamId', teamId)
            const localVarPath = `/api/artists/{artistId}/teams/{teamId}/Projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"artistId"}}`, encodeURIComponent(String(artistId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [workflowId] 
         * @param {string} [teamId] 
         * @param {boolean} [createPartialProject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsGet: async (workflowId?: string, teamId?: string, createPartialProject?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workflowId !== undefined) {
                localVarQueryParameter['workflowId'] = workflowId;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }

            if (createPartialProject !== undefined) {
                localVarQueryParameter['createPartialProject'] = createPartialProject;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [createNewProject] 
         * @param {string} [workflowId] 
         * @param {string} [projectId] 
         * @param {string} [nodeId] 
         * @param {UserSubmission} [userSubmission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsPost: async (createNewProject?: boolean, workflowId?: string, projectId?: string, nodeId?: string, userSubmission?: UserSubmission, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createNewProject !== undefined) {
                localVarQueryParameter['createNewProject'] = createNewProject;
            }

            if (workflowId !== undefined) {
                localVarQueryParameter['workflowId'] = workflowId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSubmission, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdGet: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdGet', 'projectId', projectId)
            const localVarPath = `/api/Projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId2 
         * @param {string} [workflowId] 
         * @param {string} [teamId] 
         * @param {boolean} [createPartialProject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsGet: async (teamId2: string, workflowId?: string, teamId?: string, createPartialProject?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId2' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsGet', 'teamId2', teamId2)
            const localVarPath = `/api/teams/{teamId}/Projects`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId2)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workflowId !== undefined) {
                localVarQueryParameter['workflowId'] = workflowId;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }

            if (createPartialProject !== undefined) {
                localVarQueryParameter['createPartialProject'] = createPartialProject;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {boolean} [createNewProject] 
         * @param {string} [workflowId] 
         * @param {string} [projectId] 
         * @param {string} [nodeId] 
         * @param {UserSubmission} [userSubmission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsPost: async (teamId: string, createNewProject?: boolean, workflowId?: string, projectId?: string, nodeId?: string, userSubmission?: UserSubmission, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsPost', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/Projects`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createNewProject !== undefined) {
                localVarQueryParameter['createNewProject'] = createNewProject;
            }

            if (workflowId !== undefined) {
                localVarQueryParameter['workflowId'] = workflowId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSubmission, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdGet: async (projectId: string, teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdGet', 'projectId', projectId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/Projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} artistId 
         * @param {string} teamId2 
         * @param {string} [workflowId] 
         * @param {string} [teamId] 
         * @param {boolean} [createPartialProject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistsArtistIdTeamsTeamIdProjectsGet(artistId: string, teamId2: string, workflowId?: string, teamId?: string, createPartialProject?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistsArtistIdTeamsTeamIdProjectsGet(artistId, teamId2, workflowId, teamId, createPartialProject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiArtistsArtistIdTeamsTeamIdProjectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} artistId 
         * @param {boolean} [createNewProject] 
         * @param {string} [workflowId] 
         * @param {string} [projectId] 
         * @param {string} [nodeId] 
         * @param {UserSubmission} [userSubmission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistsArtistIdTeamsTeamIdProjectsPost(teamId: string, artistId: string, createNewProject?: boolean, workflowId?: string, projectId?: string, nodeId?: string, userSubmission?: UserSubmission, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistsArtistIdTeamsTeamIdProjectsPost(teamId, artistId, createNewProject, workflowId, projectId, nodeId, userSubmission, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiArtistsArtistIdTeamsTeamIdProjectsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} artistId 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet(projectId: string, artistId: string, teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet(projectId, artistId, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [workflowId] 
         * @param {string} [teamId] 
         * @param {boolean} [createPartialProject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsGet(workflowId?: string, teamId?: string, createPartialProject?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsGet(workflowId, teamId, createPartialProject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [createNewProject] 
         * @param {string} [workflowId] 
         * @param {string} [projectId] 
         * @param {string} [nodeId] 
         * @param {UserSubmission} [userSubmission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsPost(createNewProject?: boolean, workflowId?: string, projectId?: string, nodeId?: string, userSubmission?: UserSubmission, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsPost(createNewProject, workflowId, projectId, nodeId, userSubmission, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdGet(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdGet(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId2 
         * @param {string} [workflowId] 
         * @param {string} [teamId] 
         * @param {boolean} [createPartialProject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsGet(teamId2: string, workflowId?: string, teamId?: string, createPartialProject?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsGet(teamId2, workflowId, teamId, createPartialProject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiTeamsTeamIdProjectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {boolean} [createNewProject] 
         * @param {string} [workflowId] 
         * @param {string} [projectId] 
         * @param {string} [nodeId] 
         * @param {UserSubmission} [userSubmission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsPost(teamId: string, createNewProject?: boolean, workflowId?: string, projectId?: string, nodeId?: string, userSubmission?: UserSubmission, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsPost(teamId, createNewProject, workflowId, projectId, nodeId, userSubmission, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiTeamsTeamIdProjectsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdGet(projectId: string, teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdGet(projectId, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiTeamsTeamIdProjectsProjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectsApi - factory interface
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * 
         * @param {ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistsArtistIdTeamsTeamIdProjectsGet(requestParameters: ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistsArtistIdTeamsTeamIdProjectsGet(requestParameters.artistId, requestParameters.teamId2, requestParameters.workflowId, requestParameters.teamId, requestParameters.createPartialProject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistsArtistIdTeamsTeamIdProjectsPost(requestParameters: ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistsArtistIdTeamsTeamIdProjectsPost(requestParameters.teamId, requestParameters.artistId, requestParameters.createNewProject, requestParameters.workflowId, requestParameters.projectId, requestParameters.nodeId, requestParameters.userSubmission, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsProjectIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet(requestParameters: ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsProjectIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet(requestParameters.projectId, requestParameters.artistId, requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProjectsApiApiProjectsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsGet(requestParameters: ProjectsApiApiProjectsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectsGet(requestParameters.workflowId, requestParameters.teamId, requestParameters.createPartialProject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProjectsApiApiProjectsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsPost(requestParameters: ProjectsApiApiProjectsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectsPost(requestParameters.createNewProject, requestParameters.workflowId, requestParameters.projectId, requestParameters.nodeId, requestParameters.userSubmission, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProjectsApiApiProjectsProjectIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdGet(requestParameters: ProjectsApiApiProjectsProjectIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectsProjectIdGet(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProjectsApiApiTeamsTeamIdProjectsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsGet(requestParameters: ProjectsApiApiTeamsTeamIdProjectsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdProjectsGet(requestParameters.teamId2, requestParameters.workflowId, requestParameters.teamId, requestParameters.createPartialProject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProjectsApiApiTeamsTeamIdProjectsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsPost(requestParameters: ProjectsApiApiTeamsTeamIdProjectsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdProjectsPost(requestParameters.teamId, requestParameters.createNewProject, requestParameters.workflowId, requestParameters.projectId, requestParameters.nodeId, requestParameters.userSubmission, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProjectsApiApiTeamsTeamIdProjectsProjectIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdGet(requestParameters: ProjectsApiApiTeamsTeamIdProjectsProjectIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdGet(requestParameters.projectId, requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiArtistsArtistIdTeamsTeamIdProjectsGet operation in ProjectsApi.
 */
export interface ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsGetRequest {
    readonly artistId: string

    readonly teamId2: string

    readonly workflowId?: string

    readonly teamId?: string

    readonly createPartialProject?: boolean
}

/**
 * Request parameters for apiArtistsArtistIdTeamsTeamIdProjectsPost operation in ProjectsApi.
 */
export interface ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsPostRequest {
    readonly teamId: string

    readonly artistId: string

    readonly createNewProject?: boolean

    readonly workflowId?: string

    readonly projectId?: string

    readonly nodeId?: string

    readonly userSubmission?: UserSubmission
}

/**
 * Request parameters for apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet operation in ProjectsApi.
 */
export interface ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsProjectIdGetRequest {
    readonly projectId: string

    readonly artistId: string

    readonly teamId: string
}

/**
 * Request parameters for apiProjectsGet operation in ProjectsApi.
 */
export interface ProjectsApiApiProjectsGetRequest {
    readonly workflowId?: string

    readonly teamId?: string

    readonly createPartialProject?: boolean
}

/**
 * Request parameters for apiProjectsPost operation in ProjectsApi.
 */
export interface ProjectsApiApiProjectsPostRequest {
    readonly createNewProject?: boolean

    readonly workflowId?: string

    readonly projectId?: string

    readonly nodeId?: string

    readonly userSubmission?: UserSubmission
}

/**
 * Request parameters for apiProjectsProjectIdGet operation in ProjectsApi.
 */
export interface ProjectsApiApiProjectsProjectIdGetRequest {
    readonly projectId: string
}

/**
 * Request parameters for apiTeamsTeamIdProjectsGet operation in ProjectsApi.
 */
export interface ProjectsApiApiTeamsTeamIdProjectsGetRequest {
    readonly teamId2: string

    readonly workflowId?: string

    readonly teamId?: string

    readonly createPartialProject?: boolean
}

/**
 * Request parameters for apiTeamsTeamIdProjectsPost operation in ProjectsApi.
 */
export interface ProjectsApiApiTeamsTeamIdProjectsPostRequest {
    readonly teamId: string

    readonly createNewProject?: boolean

    readonly workflowId?: string

    readonly projectId?: string

    readonly nodeId?: string

    readonly userSubmission?: UserSubmission
}

/**
 * Request parameters for apiTeamsTeamIdProjectsProjectIdGet operation in ProjectsApi.
 */
export interface ProjectsApiApiTeamsTeamIdProjectsProjectIdGetRequest {
    readonly projectId: string

    readonly teamId: string
}

/**
 * ProjectsApi - object-oriented interface
 */
export class ProjectsApi extends BaseAPI {
    /**
     * 
     * @param {ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistsArtistIdTeamsTeamIdProjectsGet(requestParameters: ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiArtistsArtistIdTeamsTeamIdProjectsGet(requestParameters.artistId, requestParameters.teamId2, requestParameters.workflowId, requestParameters.teamId, requestParameters.createPartialProject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistsArtistIdTeamsTeamIdProjectsPost(requestParameters: ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsPostRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiArtistsArtistIdTeamsTeamIdProjectsPost(requestParameters.teamId, requestParameters.artistId, requestParameters.createNewProject, requestParameters.workflowId, requestParameters.projectId, requestParameters.nodeId, requestParameters.userSubmission, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsProjectIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet(requestParameters: ProjectsApiApiArtistsArtistIdTeamsTeamIdProjectsProjectIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiArtistsArtistIdTeamsTeamIdProjectsProjectIdGet(requestParameters.projectId, requestParameters.artistId, requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsGet(requestParameters: ProjectsApiApiProjectsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsGet(requestParameters.workflowId, requestParameters.teamId, requestParameters.createPartialProject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsPost(requestParameters: ProjectsApiApiProjectsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsPost(requestParameters.createNewProject, requestParameters.workflowId, requestParameters.projectId, requestParameters.nodeId, requestParameters.userSubmission, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsProjectIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdGet(requestParameters: ProjectsApiApiProjectsProjectIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdGet(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiTeamsTeamIdProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsGet(requestParameters: ProjectsApiApiTeamsTeamIdProjectsGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiTeamsTeamIdProjectsGet(requestParameters.teamId2, requestParameters.workflowId, requestParameters.teamId, requestParameters.createPartialProject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiTeamsTeamIdProjectsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsPost(requestParameters: ProjectsApiApiTeamsTeamIdProjectsPostRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiTeamsTeamIdProjectsPost(requestParameters.teamId, requestParameters.createNewProject, requestParameters.workflowId, requestParameters.projectId, requestParameters.nodeId, requestParameters.userSubmission, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiTeamsTeamIdProjectsProjectIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdGet(requestParameters: ProjectsApiApiTeamsTeamIdProjectsProjectIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdGet(requestParameters.projectId, requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }
}

